/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './AccountListItem.module.scss';

const AccountListItem = ({ icon, title, subTitle = '', ...props }) => (
    <div className={styles.accountListItem}>
        {icon && (
            <div
                className={`${styles.accountListItemIcon} accountListItemIcon`}
            >
                {icon}
            </div>
        )}
        <div className={styles.accountListItemTitles} {...props}>
            <div
                className={`${styles.accountListItemTitle} accountListItemTitle`}
            >
                {title}
            </div>
            {subTitle && (
                <div
                    className={`${styles.accountListItemSubTitle} accountListItemSubtitle`}
                >
                    {subTitle}
                </div>
            )}
        </div>
    </div>
);

AccountListItem.propTypes = {
    /** icon: React MUI icon component */
    icon: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.func
    ]),
    /** title: The title of the item */
    title: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]).isRequired,
    /** subTitle: Subtitle of the item */
    subTitle: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
    ]),
};

export default AccountListItem;
